import { cn } from '@/lib/utils.js';

export type PaginationProps = {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  className?: string;
  /** Show even when only one page (useful while loading totals). Default: hide when totalPages <= 1 */
  alwaysShow?: boolean;
};

export function Pagination({
  page,
  pageSize,
  total,
  onPageChange,
  className,
  alwaysShow = false,
}: PaginationProps) {
  const safePageSize = Math.max(1, pageSize || 1);
  const totalPages = Math.max(1, Math.ceil(Math.max(0, total) / safePageSize));
  const current = Math.min(Math.max(1, page), totalPages);

  if (!alwaysShow && totalPages <= 1) return null;

  return (
    <div className={cn('flex items-center justify-between gap-3 text-sm', className)}>
      <p className="text-slate-500">
        Page {current} of {totalPages} · {total} total
      </p>
      <div className="flex gap-2">
        <button
          type="button"
          disabled={current <= 1}
          className="rounded-lg border border-slate-300 px-3 py-1.5 font-semibold disabled:opacity-40"
          onClick={() => onPageChange(Math.max(1, current - 1))}
        >
          Previous
        </button>
        <button
          type="button"
          disabled={current >= totalPages}
          className="rounded-lg border border-slate-300 px-3 py-1.5 font-semibold disabled:opacity-40"
          onClick={() => onPageChange(Math.min(totalPages, current + 1))}
        >
          Next
        </button>
      </div>
    </div>
  );
}
